import { alertService } from "../services/AlertService";
const {REACT_APP_BASE_URL} = process.env;

let lastShownError = '';
let lastErrorTimestamp = 0;
const ERROR_COOLDOWN = 1000;

export const handleError = (
    err,
    {
      SERVER_ERROR = "Errore del server: si è verificato un problema con il server.",
      RESOURCE_ALREADY_EXISTS = "Risorsa già esistente: la risorsa che si sta tentando di creare già esiste.",
      INVALID_CREDENTIAL = "Credenziali non valide: l'utente o la password inseriti non sono corretti.",
      USER_NOT_ACTIVE = "Utente non attivo.",
      USER_ALREADY_ACTIVE = "L'Utente risulta già attivo.",
      ACCESS_DENIED = "Non sei autorizzato per la seguente richiesta",
      EMAIL_ERROR = "Errore durante invio email",
      NOT_FOUND = "Risorsa non trovata",
      AUTH_HEADER_MISSING = "La sessione non è valida",
      REFRESH_TOKEN_INVALID = "Sessione scaduta",
      USER_BLACKLISTED = "Utente disabilitato",
      FILE_NOT_FOUND = "File non trovato",
      ACCESS_TOKEN_EXPIRED = "Token scaduto",
      ACCESS_TOKEN_INVALID = "Token non valido",
      UNAUTHORIZED = "Non sei autorizzato per la seguente richiesta",
    } = {}
  ) => {
    if (err?.message?.includes('NetworkError') || err?.status === 401) {
        forcedLogout();
        return;
    }

    let errorToDisplay = 'Si è verificato un errore';
   
    switch (err?.error?.code) {
      case 'SERVER_ERROR':
        errorToDisplay = SERVER_ERROR;
        break;
      case 'VALIDATION_ERROR':
        errorToDisplay = buildErrorMessage(err?.error?.details);
        break;
      case 'RESOURCE_ALREADY_EXISTS':
        errorToDisplay = RESOURCE_ALREADY_EXISTS;
        break;
      case 'INVALID_CREDENTIAL':
        errorToDisplay = INVALID_CREDENTIAL;
        break;
      case 'USER_NOT_ACTIVE':
        errorToDisplay = USER_NOT_ACTIVE;
        break;
      case 'USER_ALREADY_ACTIVE':
        errorToDisplay = USER_ALREADY_ACTIVE;
        break;
      case 'ACCESS_DENIED':
        errorToDisplay = ACCESS_DENIED;
        break;
      case 'NOT_FOUND':
        errorToDisplay = NOT_FOUND;
        break;
      case 'EMAIL_ERROR':
        errorToDisplay = EMAIL_ERROR;
        break;
      case 'USER_BLACKLISTED':
        errorToDisplay = USER_BLACKLISTED;
        break;
      case 'FILE_NOT_FOUND':
        errorToDisplay = FILE_NOT_FOUND;
        break;
      case 'REFRESH_TOKEN_INVALID':
        forcedLogout(errorToDisplay);
        break;
      case 'ACCESS_TOKEN_EXPIRED':
        forcedLogout(errorToDisplay);
        break;
      case 'AUTH_HEADER_MISSING':
        forcedLogout(errorToDisplay);
        break;
      case 'ACCESS_TOKEN_INVALID':
        forcedLogout(errorToDisplay);
        break;
      case 'UNAUTHORIZED':
        forcedLogout(errorToDisplay);
        break;
      default:
        break;
    }

    const currentTime = Date.now();
    if (errorToDisplay && (errorToDisplay !== lastShownError || currentTime - lastErrorTimestamp > ERROR_COOLDOWN)) {
      alertService.warn(errorToDisplay, {autoClose: true});
      lastShownError = errorToDisplay;
      lastErrorTimestamp = currentTime;
    }
};

function forcedLogout(errorToDisplay) { 
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("idSP");
  window.location.pathname = `${REACT_APP_BASE_URL}/accedi`
  errorToDisplay = '';
}

function buildErrorMessage(errors = []) {
    let missingFields = [];
    let invalidFields = [];
    errors?.forEach(error => {
        for (const key in error) {
            if (error.hasOwnProperty(key)) {
                const fieldValue = error[key];
                if (fieldValue?.required) {
                    missingFields.push(key);
                }
                else if (fieldValue?.invalid) {
                    invalidFields.push(fieldValue?.invalid);
                }
            }
        }
    });
    let errorMessage = '';

    if (missingFields?.length > 0) {
        errorMessage += 'Campi obbligatori: ' + formatTextErrors(missingFields);
    }

    if (invalidFields?.length > 0) {
        errorMessage += formatTextErrors(invalidFields);
    }

    return errorMessage || "Errore di validazione: i dati inseriti non sono validi.";
}


function formatTextErrors(fields) {
    let messages = [];

    fields?.forEach(field => {
        switch (field) {
            case 'tipo_utente':
                messages.push('ruolo');
                break;
            default:
                messages.push(field);
                break;
        }
    });
    return messages.join(', ') + '. '; 
}
